import { render, staticRenderFns } from "./DashInventoryClientContact.vue?vue&type=template&id=438f6969&scoped=true&"
import script from "./DashInventoryClientContact.vue?vue&type=script&lang=js&"
export * from "./DashInventoryClientContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438f6969",
  null
  
)

export default component.exports